import React from "react";

function Footer() {
  return (
    <div className="text-center text-white pt-24 pb-4">
      <span
        className="text-sm 
        md:text-base"
      >
        This app is not associated with pokemon company.
        <br />
        <br /> Credits: AtomicmonkeyTCG.deviantart.com
        <br />
        2023 &copy; Fan-made and crafted ❤️ by Plousious
      </span>
    </div>
  );
}

export default Footer;
